import request from '@/utils/request'
import config from '@/config'

export default {
  data() {
    return {
      settings: {
        site_name: '',
        site_description: '',
        site_keywords: '',
        contact_phone: '',
        contact_email: '',
        address: '',
        wechat_qrcode: '',
        douyin_qrcode: '',
        icp_number: '',
        copyright_text: ''
      },
      settingsLoaded: false
    }
  },
  methods: {
    async fetchSettings() {
      try {
        const settingsPath = config.api.settings.public
        if (!settingsPath) {
          console.warn('API 路径未定义')
          return
        }
        const res = await request.get(settingsPath)
        
        // 检查返回的数据格式（注意：res.data.data 才是实际数据）
        if (res.data && res.data.code === 200 && res.data.data) {
          const apiData = res.data.data
          
          if (Array.isArray(apiData)) {
            // 如果是数组格式，转换为对象
            const settingsMap = apiData.reduce((acc, item) => {
              if (item.setting_key && item.setting_value !== undefined) {
                acc[item.setting_key] = item.setting_value
              }
              return acc
            }, {})
            this.settings = { ...this.settings, ...settingsMap }
          } else if (typeof apiData === 'object') {
            // 如果已经是对象格式，直接合并
            this.settings = { ...this.settings, ...apiData }
          }
          
          console.log('Footer/Navbar settings loaded:', this.settings)
        } else {
          console.warn('API返回数据格式不正确:', res.data)
        }
        this.settingsLoaded = true
      } catch (error) {
        console.error('获取网站设置失败:', error)
        this.settingsLoaded = true
      }
    }
  }
}

